var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLangTur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "#F93939"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5272 10.5824L11.1438 11.3144L11.4081 9.76279L10.2891 8.66239L11.8367 8.43439L12.5272 7.02319L13.2176 8.43559L14.7653 8.66359L13.6462 9.76159L13.9105 11.3132",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16667 13.4C9.46786 13.4 11.3333 11.5196 11.3333 9.2C11.3333 6.8804 9.46786 5 7.16667 5C4.86548 5 3 6.8804 3 9.2C3 11.5196 4.86548 13.4 7.16667 13.4ZM8.35714 12.2C10 12.2 11.3333 10.856 11.3333 9.2C11.3333 7.544 10 6.2 8.35714 6.2C6.71429 6.2 5.38095 7.544 5.38095 9.2C5.38095 10.856 6.71429 12.2 8.35714 12.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangTur);
export default __webpack_public_path__ + "static/media/langTUR.da024b965b231b9bd0eaef0394f7b9d1.svg";
export { ForwardRef as ReactComponent };